import { render, staticRenderFns } from "./MarketRuleCommunity.vue?vue&type=template&id=171a116b&scoped=true"
import script from "./MarketRuleCommunity.vue?vue&type=script&lang=js"
export * from "./MarketRuleCommunity.vue?vue&type=script&lang=js"
import style0 from "./MarketRuleCommunity.vue?vue&type=style&index=0&id=171a116b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a116b",
  null
  
)

export default component.exports